import { render, staticRenderFns } from "./TorAbschlussWaehlenModal.vue?vue&type=template&id=c6fd2d84&"
import script from "./TorAbschlussWaehlenModal.vue?vue&type=script&lang=js&"
export * from "./TorAbschlussWaehlenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports